import playgroundSagas from "./playground";

export const canvasSagas = [
	...playgroundSagas
];

export default canvasSagas;
